import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {MonthlyReportForClinicDgSearchResults} from "../models/datagrid-search-results/monthly-report-for-clinic.dg-search-results.model";
import {MonthlyReportForClinicService} from "../providers/monthly-report-for-clinic.service";

@Injectable()
export class MonthlyReportsForClinicResolve implements Resolve<MonthlyReportForClinicDgSearchResults> {
  constructor(private monthlyReportForClinicService: MonthlyReportForClinicService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<MonthlyReportForClinicDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.monthlyReportForClinicService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
